import {
  buildCreateEventOption,
  buildMeasureOption,
  buildQrCodeOption,
  CommonContextMenuContext,
} from '@components/map/contextMenu/builders/common';
import { createContextMenuDynamicOptions } from '@components/map/contextMenu/builders/utils';
import { FeatureTypeToContextComponentEnum, MenuBuilder, MenuKey } from '@components/map/contextMenu/type';

import { MapIdEnum, OperationalMapId } from '@/types/map.types';
import { MenuItemOption } from '@/types/menu.types';

export type PerimeterCameraContextCore = {
  handleActivate: () => void;
};

export type PerimeterCameraContextMenuContext = CommonContextMenuContext & PerimeterCameraContextCore;

export type PerimeterCameraContextMenuDynamicOptions = {
  openCameraStream: boolean;
};

export type PerimeterCameraContextMenuOptions = PerimeterCameraContextMenuDynamicOptions;

export const PERIMETER_CAMERA_DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS: PerimeterCameraContextMenuDynamicOptions = {
  openCameraStream: true,
};

const allTrue = createContextMenuDynamicOptions(PERIMETER_CAMERA_DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS, true);
const allFalse = createContextMenuDynamicOptions(PERIMETER_CAMERA_DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS, false);

export const perimeterCameraContextMenuConfig: Record<OperationalMapId, PerimeterCameraContextMenuDynamicOptions> = {
  [MapIdEnum.LIVE]: allTrue,
  [MapIdEnum.LAD]: allTrue,
  [MapIdEnum.REPLAY]: allFalse,
  [MapIdEnum.STATISTICS]: allFalse,
};

const buildOpenCameraStreamOption: MenuBuilder<FeatureTypeToContextComponentEnum.PERIMETER_CAMERA>['build'] = (
  ctx,
): [MenuKey, MenuItemOption] => [
  'openCameraStream',
  {
    label: 'contextmenu.actions.openCameraStream',
    onAction: ctx.handleActivate,
  },
];

export const perimeterCameraBuilders: MenuBuilder<FeatureTypeToContextComponentEnum.PERIMETER_CAMERA>[] = [
  {
    order: 1,
    build: buildQrCodeOption,
  },
  {
    order: 2,
    build: buildMeasureOption,
  },
  {
    order: 3,
    build: buildCreateEventOption,
  },
  {
    order: 4,
    separator: true,
  },
  {
    order: 5,
    build: buildOpenCameraStreamOption,
  },
];
